import { useDeusExMachina } from '../hocs/with-deus-ex-machina'

export function useIsOneStone(): boolean {
  const { deusExMachina } = useDeusExMachina()

  return deusExMachina?.entity?.stoneAccount?.situation === 'one_stone'
}
